import { CardPayingOffOptionsEnum } from './types';

export const addCardQuestions: Record<string, any> = {
  fullName: {
    labelKey: 'applicationForm.ADD_CARD.mainHolder.label',
    firstNamePlaceholder: 'placeholders.firstName',
    lastNamePlaceholder: 'placeholders.lastName',
  },
  payingOff: {
    labelKey: 'applicationForm.ADD_CARD.payingOff.label',
    options: [
      { labelKey: 'applicationForm.ADD_CARD.payOff.label', value: CardPayingOffOptionsEnum.PAY_OFF },
      { labelKey: 'applicationForm.ADD_CARD.leaveBalance.label', value: CardPayingOffOptionsEnum.LEAVE_BALANCE },
    ],
  },
  balance: {
    labelKey: 'applicationForm.ADD_CARD.balance.label',
    placeholder: '0',
  },
};
